<template>
  <div class="searchOldTreePage">
    <div class="searchTit clearfix">
      <a href="javascript:void(0);" @click="goBack">
        <van-icon name="arrow-left" />
      </a>
      <p>{{ $t("searchMsg.searchOldTreeTit") }}</p>
    </div>
    <div class="searchBox">
      <van-cell-group>
        <van-field
          v-model="searchValue.code"
          :label="$t('common.serialNumberTit') + '：'"
          :placeholder="$t('searchMsg.numberTitleTip')"
          clickable
        />
        <van-field
          v-model="searchValue.entryName"
          :label="$t('common.speciesTit') + '：'"
          :placeholder="$t('searchMsg.shuZhongTitleTip')"
          clearable
        ></van-field>
        <van-field
          v-model="searchArea"
          :label="$t('common.politicalTit') + '：'"
          :placeholder="$t('searchMsg.searchTit')"
          readonly
          center
          @click="areaShowPicker = true"
          class="searchType"
        ></van-field>
        <van-button type="primary" size="small" @click="reloadResultList">{{
          $t("common.search")
        }}</van-button>
      </van-cell-group>
    </div>
    <div :class="['searchMain', this.showNonePage == true ? 'hideText' : '']">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        :finished-text="$t('common.noneMore')"
        class="resultList"
      >
        <van-cell
          v-for="item in resultData"
          :key="item.id"
          class="item"
          @click="setMap(item)"
        >
          <p class="clearfix">
            {{ item.entryName }}
            <span class="fr">{{
              item.xianName
                ? item.xianName
                : "" + item.xiangName
                ? item.xiangName
                : "" + item.cunName
                ? item.cunName
                : ""
            }}</span>
          </p>
          <p class="clearfix">
            <span>{{ $t("common.treeAgeTit") }}：{{ item.treeAge }}</span>
            <span>{{ $t("oldTree.diMingTit") }}：{{ item.placeName }}</span>
            <span>{{ $t("searchMsg.bhDj") }}：{{ item.treeClasses }}</span>
          </p>
        </van-cell>
      </van-list>
      <div class="nonePage" v-if="showNonePage">
        <img :src="nonePng" alt />
        <p>{{ $t("common.noDataTip") }}</p>
      </div>
    </div>
    <!-- 弹出层 -->
    <!-- 省、市、县/区、乡/镇、村两级联动 -->
    <van-popup v-model="areaShowPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="citys"
        value-key="zqName"
        cancel-button-text="清空"
        @cancel="onClearArea"
        @confirm="onSaveArea"
      />
    </van-popup>
    <!-- 古树详情 弹框 -->
    <div class="oldTreeStyle" v-if="showOldTreeType">
      <p :class="['zgc']">
        <a href="javascript:void(0);" @click="closePage">
          <i class="van-icon van-icon-arrow-left"></i>
        </a>
        详情
      </p>

      <!-- 古树详情 -->
      <olfTree
        :param="{
          id: this.dataInfo.objid,
          type: this.dataInfo.type,
          showMap: false,
        }"
      />
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import olfTree from "../universal/oldTree";
import { getaeraList } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { mapState } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "searchOldTree",
  data() {
    return {
      editType: true, //防止多次点击搜索按钮
      nonePng: nonePng, //默认图片
      showNonePage: false, //
      searchArea: "",
      searchValue: {
        code: "", //编号
        entryName: "", //树种
        regionCode: "", //城市区域码
        selectType: "2",
        areaType: "",
        objid: "",
      }, //搜索值
      resultData: [],
      areaShowPicker: false, //
      backstagelists: [],
      page: 0,
      pageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      citys: [],
      showOldTreeType: false, //是否显示政区详情
      dataInfo: {
        objid: "",
        type: "",
      }, //向子组件传值
      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.searchObj && this.userinfo) {
        this.getLogin();
      }
    });
    // this.initPage();
    // this.getCitys();
  },
  components: {
    olfTree,
  },
  methods: {
    getLogin() {
      let _this = this;
      let zqList = ["geo_sheng", "geo_shi", "geo_xian", "geo_xiang", "geo_cun"];
      let zqType = "zrq";
      _this.$api.slbkOldTree
        .getLztToGsLogin()
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.searchValue.regionCode = res.data.zqCode;
            zqList.forEach((item) => {
              if (item == this.searchObj.zrqlx) {
                zqType = "zq";
              }
            });
            this.$set(this.searchValue, "areaType", zqType);
            this.$set(this.searchValue, "objid", this.searchObj.objid);
            this.getCitys();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getCitys() {
      this.citys = await getaeraList(this.searchValue.regionCode);
    },

    getTest() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.search
        .resourceGushuList(_this.page, _this.pageSize, _this.searchValue)
        .then((res) => {
          if (res.code == "1") {
            _this.editType = true;
            let total = parseInt(res.data.total);
            _this.commentCount = total;
            _this.backstagelists = res.data.list;

            _this.viewLists();
            // 加载状态结束
            _this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;

              console.log("加载完成");
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
    viewLists() {
      this.resultData = this.resultData.concat(this.backstagelists);
      if (this.resultData.length < 1) {
        this.showNonePage = true;
      } else {
        this.showNonePage = false;
      }
    },

    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
    reloadResultList() {
      let _this = this;
      let zqList = ["geo_sheng", "geo_shi", "geo_xian", "geo_xiang", "geo_cun"];
      let zqType = "zrq";
      if (_this.editType) {
        _this.editType = false;
        _this.showNonePage = false;
        _this.loading = true; //是否处于加载状态
        _this.finished = false;
        zqList.forEach((item) => {
          if (item == this.searchObj.zrqlx) {
            zqType = "zq";
          }
        });
        this.$set(this.searchValue, "areaType", zqType);
        this.$set(this.searchValue, "objid", this.searchObj.objid);
        _this.searchValue.regionCode == ""
          ? (_this.searchValue.regionCode = _this.searchObj.zqCode
              ? _this.searchObj.zqCode
              : _this.userinfo.zqCode)
          : (_this.searchValue.regionCode = _this.searchValue.regionCode);
        _this.page = 0;
        _this.commentCount = 0;
        _this.resultData = [];
        _this.getTest();
      } else {
        _this.$toast(_this.$t("common.moreClickToastMsg"));
      }
    },
    onSaveArea(value, index) {
      this.searchArea = value[0] + value[1];
      this.searchValue.regionCode =
        this.citys[index[0]].children[index[1]].zqCode;
      this.areaShowPicker = false;
    },
    onClearArea() {
      //清空政区内容
      this.searchArea = "";
      this.searchValue.regionCode = "";
      this.areaShowPicker = false;
    },
    goBack() {
      let _this = this;
      _this.$emit("changeType", true);
      this.$store.commit("SetcloseShowType", "open");
    },
    setMap(data) {
      let _this = this;

      _this.$set(_this.dataInfo, "objid", data.id);
      _this.$set(_this.dataInfo, "type", "geo_gushu");

      _this.$api.universal.oldTree
        .oldTreeMsg(data.id)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.$set(_this.dataInfo, "postionMsg", {
              pointX: res.data.lon,
              pointY: res.data.lat,
              xDiMing: res.data.shiName + res.data.xiangName + res.data.cunName,
            });
          }
          this.showOldTreeType = true; //显示古树详情
          this.$store.commit("SetcloseShowType", "close");
          this.$emit("getMapOptions", this.dataInfo);
        })
        .catch(() => {
          this.showOldTreeType = true; //显示古树详情
          this.$store.commit("SetcloseShowType", "close");
          this.$emit("getMapOptions", this.dataInfo);
        });
    },
    closePage() {
      //关闭详情页
      this.showOldTreeType = false;
      this.$store.commit("SetcloseShowType", "open");
    },
  },
  computed: {
    ...mapState(["userinfo", "searchObj"]),
  },
  watch: {
    searchObj: {
      handler: function () {
        // let _this = this;
        // this.searchValue.gridType = this.searchObj.zrqlx;
        // this.searchValue.objid = this.searchObj.objid;
        if (this.searchObj) {
          _this.getLogin();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.searchOldTreePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;

  .searchTit {
    width: 100%;
    padding: 0 16px;
    background-color: #fff;
    position: relative;

    a {
      display: inline-block;
      width: 55px;
      padding-left: 15px;
      line-height: 40px;
      font-size: 14px;
      color: #4bc08a;
      position: relative;

      .van-icon {
        position: absolute;
        left: 0;
        top: 11px;
        display: inline-block;
        font-size: 14px;
        color: #4bc08a;
        font-weight: 600;
      }
    }

    p {
      width: 200px;
      line-height: 40px;
      margin: 0 auto;
      color: #666;
      text-align: center;
      font-size: 14px;
    }
  }

  .searchBox {
    width: 100%;
    position: relative;

    .van-cell {
      width: 100%;
      height: 46px;
      padding: 8px 16px;
      box-sizing: border-box;

      .van-field__label {
        color: #666;
        font-size: 12px;

        span {
          line-height: 30px;
        }
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }

    .searchType.van-cell {
      width: 80%;
    }

    .van-button {
      position: absolute;
      right: 16px;
      bottom: 9px;
    }
  }

  .searchMain {
    width: 100%;
    height: 59%;
    overflow-y: scroll;
    background-color: #f6f6f6;
    position: relative;
    .resultList {
      width: 100%;
      padding: 0 8px;

      .item {
        width: 100%;
        background-color: #fff;
        margin: 10px 0;
        padding: 8px 8px;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-borer-radius: 8px;

        p {
          color: #636464;
          font-size: 12px;
          line-height: 20px;
          margin: 10px 0;
        }

        p:first-child {
          font-weight: 600;
          font-size: 14px;
          span {
            float: right;
            font-size: 10px;
            font-weight: 400;
          }
        }

        p:last-child {
          span {
            display: inline-block;
            font-size: 10px;
            color: #666;
            text-align: center;
          }
          span:first-child {
            width: 25%;
            text-align: left;
          }
          span:nth-child(2) {
            width: 45%;
          }
          span:last-child {
            width: 30%;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .searchMain.hideText {
    .van-list__finished-text {
      display: none;
    }
  }

  .oldTreeStyle {
    position: absolute;
    width: 100%;
    height: calc(100% - 40px);
    top: 40px;
    left: 0;
    padding-top: 40px;
    z-index: 9999 !important;
    background-color: #fff;
    .zgc {
      position: absolute;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      text-align: center;
      top: 0;
      left: 0;
      color: #646566;
      font-size: 15px;
      a {
        display: inline-block;
        width: 45px;
        color: #4bc08a;

        position: absolute;
        left: 15px;
        top: 0px;
        text-align: left;
        .van-icon {
          display: inline-block;
          font-size: 16px;
          line-height: 35px;
          color: #4bc08a;
          font-weight: 600;
        }
      }
    }
  }
}
</style>